/*
 * @Author: your name
 * @Date: 2022-03-16 10:10:13
 * @LastEditTime: 2022-03-16 14:48:41
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \ant-design-vue-jeecg\src\components\do\index.js
 */
import DSelect from './DSelect.vue';
import DUpload from './DUpload.vue';

export default {
  install(Vue) {
    Vue.component(DSelect.name, DSelect)
    Vue.component(DUpload.name, DUpload)
  }
}